export default __webpack_public_path__ + "i18n/translations/translation-ko.c669dd72.json";